import type { CSSProperties } from 'react';

import type { IconName } from './sprite';

export interface IconProps {
  /** Prefikssiz nom: `mic`, `gem`, `micoff`. Sprite'da id `ic-*` bo'ladi. */
  name: IconName;
  /** Prototipdagi o'lchamlar: 8 · 11 · 13 · 14 · 15 · 18 · 19 · 20 (§12). */
  size?: number;
  /** Rang `currentColor` orqali keladi. `ic-gem` bundan mustasno. */
  color?: string;
  style?: CSSProperties;
  className?: string;
}

/**
 * Sprite'dan ikonka. `<IconSprite />` ilova ildizida bir marta bo'lishi shart.
 *
 * `aria-hidden` — ikonkalar bezak. Ma'noli bo'lsa yonidagi matn beradi;
 * matnsiz tugmada `aria-label` tugmaning o'zida turadi.
 */
export function Icon({ name, size = 18, color, style, className }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
      className={className}
      style={{ color, display: 'block', flex: '0 0 auto', ...style }}
    >
      <use href={`#ic-${name}`} />
    </svg>
  );
}
